export default {
  Home: {
    header: {
      hello_user: 'Hola {0} bienvenido a la hacienda',
      edit_farm: 'Editar Hacienda',
      enable_farm: 'Habilitar hacienda',
      sown_area: 'Area sembrada',
      enable_farm_successfully: 'Hacienda habilitada con éxito.',
      she_disabled: 'Desactivada',
    },
    header_no_farms: {
      welcome_no_farms: 'Aún no lo tienes hacienda registrada',
      manual_create_farm: 'Registre su hacienda manualmente',
      create_farm: 'Registre su hacienda',
    },
    quick_actions: {
      quick_actions: 'acciones rapidas',
      see_catalog: 'ver catalogo',
      plan_fungicide: 'plan fungicida',
      create_note: 'crear nota',
      see_fields: 'ver lotes',
      register_sowing: 'registrar siembra',
    },
    item_list: {
      fields: 'lotes',
      see_all: 'ver todo',
      active_sowings: 'siembras activas',
      sowings: 'siembras',
    },
    sowing: {
      next_spray: 'Próxima Aplicación',
      complete: 'completo',
      not_current_season:
        'La siembra no es de esta zafra. No és posible editarlo',
    },
    current_season_displayer: {
      season: 'Zafra',
    },
  },
}
